import React from 'react';
import {
  useUpdateClientAccountScoreSettingMutation,
  useAccountScoreSettingQuery,
} from 'api';
import useDebounce from 'hooks/useDebounce';

export default function CustomSlider() {
  const {data: {accountScoreSetting = {}} = {}} = useAccountScoreSettingQuery({
    fetchPolicy: 'cache-and-network',
  });
  const [update] = useUpdateClientAccountScoreSettingMutation({});
  const [weight, setWeight] = React.useState(
    accountScoreSetting?.weightSubCategory ?? null,
  );

  const debouncedValue = useDebounce<Number>(weight, 500);

  React.useEffect(() => {
    if (weight === null) {
      return;
    }
    update({
      variables: {
        attributes: {
          weightSubCategory: Number(weight),
        },
      },
    });
  }, [debouncedValue]);

  return (
    <div className="w-40 max-w-sm flex items-center gap-2">
      <div className="flex items-center justify-center">
        <input
          type="range"
          className="cursor-pointer"
          value={weight ?? accountScoreSetting?.weightSubCategory}
          min={0}
          max={5}
          onChange={(e) => setWeight(Number(e.target.value))}
        />
      </div>
      <div className="text-base font-bold">
        {weight ?? accountScoreSetting?.weightSubCategory}
      </div>
    </div>
  );
}
